export default __webpack_public_path__ + "static/media/pic36-before.8be60758.JPG";